// TypeScript mirror of src/styles/tokens.css for consumers that need values in JS (charts, tests).
// Keep in sync with tokens.css. Prefer CSS variables (`cssVar`) so a future theme applies automatically.

export const colors = {
  brand: { primary: '#2563EB', hover: '#1D4ED8', tint: '#EFF6FF', onPrimary: '#FFFFFF' },
  surface: { canvas: '#F5F6F8', default: '#FFFFFF', subtle: '#F8FAFC' },
  border: { subtle: '#E5E7EB', control: '#CBD5E1', controlStrong: '#8290A3' },
  text: { primary: '#111827', secondary: '#4B5563', muted: '#64748B' },
  status: {
    success: '#15803D',
    successBg: '#F0FDF4',
    warning: '#92400E',
    warningBg: '#FFFBEB',
    danger: '#B91C1C',
    dangerBg: '#FEF2F2',
    info: '#1D4ED8',
    infoBg: '#EFF6FF',
  },
  focus: { ring: '#2563EB' },
} as const;

/** Stable categorical chart series order. */
export const chartSeries = ['#2563EB', '#0F766E', '#7C3AED', '#B45309', '#BE185D'] as const;
export const chartPrevious = '#64748B';

/** CSS variable references, preferred inside SVG/Recharts props. */
export const cssVar = {
  chart: ['var(--cm-chart-1)', 'var(--cm-chart-2)', 'var(--cm-chart-3)', 'var(--cm-chart-4)', 'var(--cm-chart-5)'],
  chartPrevious: 'var(--cm-chart-previous)',
  grid: 'var(--cm-border-subtle)',
  axis: 'var(--cm-text-secondary)',
  muted: 'var(--cm-text-muted)',
  surface: 'var(--cm-surface-default)',
  primary: 'var(--cm-brand-primary)',
} as const;

export const radii = { control: 10, menu: 12, card: 20, dialog: 24, pill: 999 } as const;
export const spacing = [4, 8, 12, 16, 20, 24, 32, 40, 48] as const;
export const typography = {
  body: { size: 14, lineHeight: 20 },
  helper: { size: 12, lineHeight: 18 },
  heading: { size: 26, lineHeight: 34 },
  cardTitle: { size: 16, lineHeight: 24 },
  kpi: { size: 32, lineHeight: 40 },
} as const;
export const shadows = { card: '0 1px 3px rgb(15 23 42 / 0.04)', overlay: '0 12px 32px rgb(15 23 42 / 0.12)' } as const;
export const layout = { sidebarWidth: 240, topbarHeight: 72 } as const;
export const iconSize = { sm: 16, md: 18, lg: 20 } as const;
